import { useController, type Control, type FieldPath, type FieldValues } from 'react-hook-form';
import { FieldError } from './FieldError';
import { capitaliseWords, capitaliseWordsLive } from './utils';

interface Props<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  label?: string;
  placeholder?: string;
}

export const NameInput = <T extends FieldValues>({
  name,
  control,
  label,
  placeholder,
}: Props<T>) => {
  const {
    field,
    fieldState: { error },
  } = useController({ name, control });
  return (
    <div>
      {label && <label className="lbl">{label}</label>}
      <input
        ref={field.ref}
        name={field.name}
        value={(field.value as string) ?? ''}
        onChange={(e) => field.onChange(capitaliseWordsLive(e.target.value))}
        onBlur={() => field.onChange(capitaliseWords(((field.value as string) ?? '').trim()))}
        placeholder={placeholder}
        className={`inp ${error ? 'inp-error' : ''}`}
        aria-invalid={!!error}
      />
      <FieldError message={error?.message} />
    </div>
  );
};
